import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    padding: [18, 24, 22, 20],
    height: 180,
    borderBottom: `1px solid ${theme.palette.colors.border}`,
    cursor: 'pointer',
    width: '100%',
    borderRight: `2px solid transparent`,
  },
  upperBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 69,
  },
  buyerInfo: {
    height: 69,
    width: 240,
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'column',
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
  },
  name: {
    margin: [4, 0],
  },
  onineStatus: {
    color: theme.palette.colors.white,
    padding: 3,
    backgroundColor: theme.palette.colors.lightGreen,
    borderRadius: 4,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
    marginLeft: theme.spacing(1),
  },
  autoFollowups: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  autoFollowupsLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  infoIcon: {
    color: theme.palette.colors.teal,
    width: 14,
    height: 14,
    marginLeft: 4,
    marginRight: theme.spacing(2),
  },
  chatControlBar: {
    display: 'flex',
    alignItems: 'right',
  },
  iconButton: {
    padding: 0,
    marginRight: 5,
  },
  active: {
    borderRight: `2px solid ${theme.palette.colors.red}`,
    backgroundColor: theme.palette.colors.lightGray,
  },
  date: {
    marginLeft: 4,
  },
  inActive: {
    '&:hover': {
      borderRight: `2px solid ${theme.palette.colors.gray}`,
    },
  },
  unreadMessagesBadge: {
    backgroundColor: theme.palette.colors.red,
    height: 24,
    minWidth: 24,
    justifyContent: 'center',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
  },
  unredMessagesText: {
    margin: [0, 6],
    color: theme.palette.colors.white,
  },
  bottomBar: {
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.colors.divider}`,
    display: 'flex',
    alignItems: 'center',
    height: 55,
  },
  bottomBarLeft: {
    width: 110,
  },
  bottomBarCenter: {
    width: 80,
  },
  bottomBarRight: {
    width: 140,
  },
  additionalText: {
    fontSize: 16,
    marginTop: 5,
    fontWeight: '700',
    color: theme.palette.colors.darkBlueGray,
  },
  inactiveIcon: {
    fill: theme.palette.colors.border,
  },
  starIcon: {
    fill: theme.palette.colors.yellow,
  },
  icon: {
    fill: theme.palette.colors.monteCarlo,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerCard/useStyles.js